var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlutter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36.336 60.058-16.25-16.145 8.983-9.139 25.333 25.284H36.336Z",
    fill: "#02539A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.886 43.925 16.108-16.108h18.108L29.043 52.876l-9.157-8.95Z",
    fill: "#45D1FD",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.942 29.876 9.145 9.138L54.101.002H35.899L5.942 29.876Z",
    fill: "#45D1FD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.003.001h60v60h-60z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/flutter.312cec9f9e9fbb8da6d960ab30b3badb.svg";
export { ForwardRef as ReactComponent };